"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarButtonStyles_unstable", {
    enumerable: true,
    get: ()=>useToolbarButtonStyles_unstable
});
const _react = require("@griffel/react");
const _reactButton = require("@fluentui/react-button");
const useBaseStyles = /*#__PURE__*/ (0, _react["__styles"])({
    vertical: {
        Beiy3e4: "f1vx9l62"
    },
    verticalIcon: {
        Be2twd7: "f1rt2boy"
    }
}, {
    d: [
        ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}",
        ".f1rt2boy{font-size:24px;}"
    ]
});
const useToolbarButtonStyles_unstable = (state)=>{
    (0, _reactButton.useButtonStyles_unstable)(state);
    const buttonStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(state.root.className, state.vertical && buttonStyles.vertical);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(state.icon.className, state.vertical && buttonStyles.verticalIcon);
    }
}; //# sourceMappingURL=useToolbarButtonStyles.js.map

//# sourceMappingURL=useToolbarButtonStyles.js.map